function Loader() {
    return (
        <div className="commonNewLoader">
            <div className="commonProgress">
                <img src="/images/loading-gif.gif" alt="loader_image" />
                <p>Loading data</p>
            </div>
        </div>
    );
}

export default Loader;
